import PropTypes from 'prop-types';
import React, { forwardRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';

import Text from 'components/atomic/layouts/Text';

const StyledContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  gap: ${theme.spaces.large}px;
  margin-bottom: ${theme.spaces.large}px;
`;

// eslint-disable-next-line react/display-name, react/prop-types, no-unused-vars
const StyledTabContainer = styled(forwardRef(({ selected, ...props }, ref) => <div ref={ref} {...props} />))`
  position: relative;
  cursor: pointer;

  :before {
    content: '';
    display: block;
    position: absolute;
    bottom: -10px;
    left: calc(50% - 4px);
    height: 4px;
    width: 8px;
    border-radius: 8px;
    background-color: ${theme.colors.gray.primary};

    ${({ selected }) =>
      !selected &&
      css`
        display: none;
      `}
  }

  @media ${theme.devices.tablet} {
  }
`;

const NavigationTabsSection = ({ items = [] }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const handleSelect = (path) => () => {
    navigate(`../${path}`);
  };

  return (
    <StyledContainer>
      {items.map(({ title, path }) => (
        <StyledTabContainer key={path} selected={pathname === path} onClick={handleSelect(path)}>
          <Text
            desktop
            size={theme.fontSizes.largeX}
            weight={600}
            color={pathname === path ? theme.colors.gray.primary : theme.colors.gray.secondary}
          >
            {title}
          </Text>
          <Text
            mobile
            size={theme.fontSizes.small}
            weight={600}
            color={pathname === path ? theme.colors.gray.primary : theme.colors.gray.secondary}
          >
            {title}
          </Text>
        </StyledTabContainer>
      ))}
    </StyledContainer>
  );
};

NavigationTabsSection.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      path: PropTypes.string,
    })
  ),
};

export default NavigationTabsSection;
